module.exports = __webpack_public_path__ + "img/ring_tanzoUchinuki.2b231da2.png";